export default function(el, { resetTabIndex = true } = {}) {
  setTimeout(() => {
    const storedTabIndex = el.tabIndex
  
    el.tabIndex = 0
    el.focus()
  
    if (resetTabIndex) {
      el.tabIndex = storedTabIndex
  
      if (storedTabIndex === -1) {
        el.removeAttribute('tabindex')
      }
    }
  }, 0)
}



// WEBPACK FOOTER //
// ./src/helpers/focus-element.js